enum SpinnerSize {
  big = 60,
  medium = 40,
  small = 20,
}

export default SpinnerSize;
